
const getters = {
  getCalendarById: (state, getters, rootState, rootGetters) => (id) => {
    console.log(state['moduleCalendar'].calendars)
    // return rootState.moduleCalendar.calendars.find(calendar => calendar.id === id)
  },
  // calendars: state => state.calendars,
}
export default getters